import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getConsentFormName, getConsentFormsForServices } from './consentFormDisplay';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

/**
 * Tells the owner which consent forms a package or membership will ask for. They come from its
 * included services, so there is nothing to set here.
 */
const ConsentFormsSummary = ({ id, serviceIds, services, consentForms }) => {
  const { t, i18n } = useTranslation();

  if (!consentForms?.length) {
    return null;
  }

  const forms = getConsentFormsForServices(serviceIds, services, consentForms);

  return (
    <Box id={id} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {t('consentForms.derived.title')}
      </Typography>
      {forms.length > 0 ? (
        <>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
            {forms.map((form) => (
              <Chip
                key={form.id}
                size="small"
                icon={<DescriptionIcon sx={{ color: `${BRAND.accentText} !important` }} />}
                label={getConsentFormName(form.name, i18n.language, t)}
                sx={{ backgroundColor: brandAlpha('accent', 0.12), color: BRAND.accentText, fontWeight: 600 }}
              />
            ))}
          </Box>
          <Typography variant="caption" color="text.secondary">
            {t('consentForms.derived.help')}
          </Typography>
        </>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t('consentForms.derived.none')}
        </Typography>
      )}
    </Box>
  );
};

export default ConsentFormsSummary;
